export default __webpack_public_path__ + "static/media/mom_coney_island.eeca7b82.jpg";